import "./App.css";
import { Routes, Route, useLocation, Navigate } from "react-router-dom";
import { useEffect, useState } from "react";

import LoginLayout from "./Layout/LoginLayout";
import MainLayout from "./Layout/MainLayout";

import DashboardPage from "./Pages/DashboardPage";
import LoginPage from "./Pages/LoginPage";
import AccountsPage from "./Pages/AccountsPage";
import CreditsPage from "./Pages/CreditsPage";
import CreditSettingsPage from "./Pages/CreditSettingsPage";
import SendMessagePage from "./Pages/SendMessagePage";
import MessagesPage from "./Pages/MessagesPage";
import MessageDetailsPage from "./Pages/MessageDetailsPage";
import SettingsPage from "./Pages/SettingsPage";
import UserTransactionsPage from "./Pages/UserTransactionsPage";
import ContactsPage from "./Pages/ContactsPage";
import TransactionDetailPage from "./Pages/TransactionDetailPage";
import NotFoundPage from "./Pages/NotFoundPage";
import ResetPasswordPage from "./Pages/ResetPasswordPage";
import UsersPage from "./Pages/UsersPage";
import ContactUsPage from "./Pages/ContactUsPage";
import UserLicencePage from "./Pages/UserLicencePage";
import AdminsPage from "./Pages/AdminsPage";

import { ToastProvider } from "./Context/toastContext";
import Toast from "./Components/Toast";

import { L10n, setCulture } from "@syncfusion/ej2-base";
import trTranslations from "./Assets/Localization/tr.json";
import enTranslations from "./Assets/Localization/en-US.json";
import UnsubscribePage from "./Pages/UnsubscribePage";
import PrivacyPolicyPage from "./Pages/PrivacyPolicyPage";

function App() {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const isLoginPage =
    location.pathname === "/login" ||
    location.pathname.startsWith("/reset-password") ||
    location.pathname.startsWith("/unsubscribe") ||
    location.pathname.startsWith("/contactus") ||
    location.pathname.startsWith("/privacy-policy");

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    setIsAuthenticated(!!token);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 1024) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const language =
      navigator.language ||
      navigator.userLanguage ||
      localStorage.getItem("language") ||
      "en";

    if (language === "tr" || language === "tr-TR") {
      L10n.load(trTranslations);
      setCulture("tr");
      localStorage.setItem("i18nextLng", "tr");
    } else {
      L10n.load(enTranslations);
      setCulture("en-US");
      localStorage.setItem("i18nextLng", "en");
    }
  }, []);

  if (isAuthenticated === null) {
    return null; // Sayfa yüklenirken hiçbir şey gösterme
  }

  if (!isAuthenticated && !isLoginPage) {
    return <Navigate to="/login" replace />;
  }

  const onSidebarToggle = (isOpen) => {
    setIsSidebarOpen(isOpen);
  };

  return (
    <ToastProvider>
      <div className="App">
        <Toast />
        {isLoginPage ? (
          <LoginLayout />
        ) : (
          <MainLayout onSidebarToggle={onSidebarToggle} />
        )}
        <div className={`main-content-wrapper ${isSidebarOpen && !isLoginPage ? 'sidebar-open' : 'sidebar-closed'}`} style={{backgroundColor:" #eaeaea" }}>
          <div className="main-content">
            <Routes>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/accounts" element={<AccountsPage />} />
              <Route path="/admins" element={<AdminsPage />} />
              <Route path="/contacts" element={<ContactsPage />} />
              <Route path="/sendmessage" element={<SendMessagePage />} />
              <Route path="/messages" element={<MessagesPage />} />
              <Route
                path="/messages/:envelopeId"
                element={<MessageDetailsPage />}
              />
              <Route path="/credits" element={<CreditsPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/users/:id" element={<UserLicencePage />} />
              <Route
                path="/usertransactions"
                element={<UserTransactionsPage />}
              />
              <Route
                path="/usertransactions/:userId"
                element={<TransactionDetailPage />}
              />
              <Route path="/creditsettings" element={<CreditSettingsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/contactus" element={<ContactUsPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route
                path="/unsubscribe/:userId/:phoneNumber"
                element={<UnsubscribePage />}
              />
               <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="*" element={<NotFoundPage />} />
            </Routes>
          </div>
        </div>
      </div>
    </ToastProvider>
  );
}

export default App;
